<ng-container *ngIf="custom_injector">
  <ng-container *ngComponentOutlet="consentComponent;injector: custom_injector;"></ng-container>
</ng-container>
